import { bool, string } from "prop-types";
import { Button, CircularProgress } from "@material-ui/core";
import arrowRight from "./images/arrow-right.svg";

function ButtonControl(props) {
  const { className, color, disabled, form, label, processing, type } = props;

  return (
    <Button
      className={className}
      color={color}
      disabled={processing || disabled}
      form={form}
      fullWidth
      size="large"
      startIcon={
        processing ? (
          <CircularProgress
            size={18}
            style={{
              marginRight: 5,
            }}
          />
        ) : undefined
      }
      type={type}
      variant="contained"
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          children={label}
          style={{
            textAlign: "left",
          }}
        />
        <div>
          <img src={arrowRight} alt={label} />
        </div>
      </div>
    </Button>
  );
}

ButtonControl.propTypes = {
  className: string,
  color: string,
  disabled: bool,
  form: string,
  label: string,
  processing: bool,
  type: string,
};

export default ButtonControl;
